import { createGlobalStyle } from 'styled-components';
import FrankRuhlLibre from './FrankRuhlLibre-Medium.ttf';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'FrankRuhlLibre';
    src: url(${FrankRuhlLibre}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'FrankRuhlLibre', sans-serif;
    direction: rtl;
  }
`;
